<template>
  <div id="app">
    <router-view  :key="randomId"/>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {

  },
  computed: {
      randomId () {
        return this.$route.fullPath + new Date()
      }
    }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
 /* margin-top: 60px; */
}
/* body{
  background:url(assets/img/bg.jpg) no-repeat center top;
} */

</style>



// WEBPACK FOOTER //
// src/App.vue